/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const EnterpriseSequenceDiagramPage = lazyLoad(
  () => import('./index'),
  module => module.EnterpriseSequenceDiagramPage
);
